// extracted by mini-css-extract-plugin
export default {"problemSolvedGridContainer":"ProblemsSolvedGrid_problemSolvedGridContainer__18Hz-"};